module.exports = __webpack_public_path__ + "779d5c48c64bc02fcc75f2248ee5e195.gif";


//////////////////
// WEBPACK FOOTER
// ./node_modules/fg-frontend/components/CookiesPolicy/img/motive.gif
// module id = 390
// module chunks = 27